import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import PropTypes from 'prop-types'
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"

import store from "../../store"
import { SET_AUTH, CLEAR_AUTH } from "../../store/auth/profile/actionTypes"
import { LOGOUT_USER } from "store/auth/login/actionTypes"
import { CLEAR_DATA } from "store/auth/data/actionTypes"
// import PURGE
import persistor from "index"

//SimpleBar
import SimpleBar from "simplebar-react"

import { Link, useHistory } from "react-router-dom"

//Import images
import arrowRight from "../../assets/images/arrow_right.png";
import logOut from "../../assets/images/logout.png";
import { settingChange, settingConfirm } from "crud/auth.crud"

const RightSidebar = props => {
  const history = useHistory()
  const selector = useSelector(state => state)

  const [memberId, setMemberId] = useState(selector.Profile?.auth?.[0]?.id || selector.auth?.user?.id)
  const [email, setEmail] = useState(selector.Profile?.auth?.[0]?.agree_email || selector.auth?.user?.agree_email || "N")
  const [push, setPush] = useState(selector.Profile?.auth?.[0]?.agree_push || selector.auth?.user?.agree_push || "N")
  const [isChange, setIsChange] = useState(false)

  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const changePreference = async (check, type) => {
    setIsChange(true)
    let params = {}
    if(type === 'email'){
        params = {
          agree_email : check,
          agree_push : push
      }
    }
    if(type === 'push'){
      params = {
        agree_email : email,
        agree_push : check
      }
    }
    const url = memberId
    const rs = await settingChange(params, url);
    if(rs.status === 200){
        const urlPlus = selector.auth?.user?.id;
        const memberResponse = await settingConfirm(urlPlus);
        store.dispatch({ type: SET_AUTH, data: [memberResponse.data] }); 
    }
    setIsChange(false)
  }

  const handleLogout = async() => {
    localStorage.removeItem('ACCESS_TOKEN')
    localStorage.removeItem('authUser');
    store.dispatch({type: CLEAR_AUTH})
    store.dispatch({type: LOGOUT_USER})
    store.dispatch({type: CLEAR_DATA})
    await persistor.purge()
    //history.push('main')
  }

  useEffect(()=>{

  }, [])

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="mdi mdi-cog-outline"></i>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 alarm custom">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0 font-size-14"> {"설정"}</h6>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ padding: '0 1rem 1rem 1rem' }}>
            <div className="text-reset p-3 bg-white mt-2 radius-4">

              <div className="radio-toolbar d-flex justify-content-between align-items-center mb-3">
                <span className="mb-0 d-block font-size-14 text-black">이메일 수신 동의</span>
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" defaultChecked={email == "Y"}
                  onChange={(e)=>{
                    if(!isChange){
                      changePreference(e.target.checked ? "Y" : "N", 'email')
                    }else{
                      e.target.checked ? e.target.checked = false : e.target.checked = true
                    }
                  }} />
                </div>
              </div>

              <div className="radio-toolbar d-flex justify-content-between align-items-center mb-3">
                <span className="mb-0 d-block font-size-14 text-black">앱 푸시 알람 수신 동의</span>
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" defaultChecked={push == "Y"}
                  onChange={(e)=>{
                    if(!isChange){
                      changePreference(e.target.checked ? "Y" : "N", 'push')
                    }else{
                      e.target.checked ? e.target.checked = false : e.target.checked = true
                    }
                  }} />
                </div>
              </div>

              <div className="radio-toolbar d-flex justify-content-between mb-3">
                <span className="d-block text-black">WASTEVERSE 버전</span>
                <span className="d-block text-black">1.0</span>
              </div>

              <div className="radio-toolbar d-flex justify-content-between pointer mb-1" onClick={(e)=>{
                e.preventDefault()
                handleLogout()
              }}>
                <span className="d-block text-block font-weight-bold">로그아웃 하기</span>
                <img src={logOut} width={16} height={16} />
              </div>

              {/* <div className="d-flex">
                <Link to="/contract-management-screen" className="flex-1">
                  <h6 className="mt-0 mb-1 font-size-16" style={{color: "#000"}}>asda</h6>
                  <div className="font-size-14 text-muted">
                    <p className="mt-1 text-gray mb-0">asdas</p>
                  </div>
                </Link>
                <div style={{cursor: "pointer"}} onClick={()=>{
                  deleteAlarm(item.id)
                }}>
                  <p className="text-error">X</p>
                </div>
              </div> */}
            </div>
          </SimpleBar>
          {/* <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="#"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>
              {" "}
              {props.t("더 보기")}{" "}
            </Link>
          </div> */}
        </DropdownMenu>
      </Dropdown>
      {/* <div className="right-bar">
        <SimpleBar style={{ height: "900px" }}>
          <div data-simplebar className="h-100">
            <div className="rightbar-title px-3 py-4">
              <Link
                to="#"
                onClick={e => {
                  e.preventDefault()
                  props.showSettingbarAction(false)
                }}
                className="right-bar-toggle float-end"
              >
                <i className="mdi mdi-close noti-icon" />
              </Link>
              <h5 className="m-0">설정</h5>
            </div>

            <hr className="my-0" />
                  
            <div className="p-4">
              <div className="radio-toolbar" style={{display: "flex", justifyContent: "space-between"}}>
                <span className="mb-2 d-block">이메일 수신 동의</span>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" defaultChecked={email == "Y"}
                  onChange={(e)=>{
                    if(!isChange){
                      changePreference(e.target.checked ? "Y" : "N", 'email')
                    }else{
                      e.target.checked ? e.target.checked = false : e.target.checked = true
                    }
                  }} />
                </div>
              </div>

              <hr className="mt-1" />

              <div className="radio-toolbar" style={{display: "flex", justifyContent: "space-between"}}>
                <span className="mb-2 d-block">앱 푸시 알람 수신 동의</span>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" defaultChecked={push == "Y"}
                  onChange={(e)=>{
                    if(!isChange){
                      changePreference(e.target.checked ? "Y" : "N", 'push')
                    }else{
                      e.target.checked ? e.target.checked = false : e.target.checked = true
                    }
                  }} />
                </div>
              </div>
              <hr className="mt-1" />

              <div className="radio-toolbar" style={{display: "flex", justifyContent: "space-between"}}>
                <span className="mb-2 d-block">WASTEVERSE 버전</span>
                <span className="mb-2 d-block">1.0</span>
              </div>
              <hr className="mt-1" />

              <div className="radio-toolbar" style={{display: "flex", justifyContent: "space-between", cursor: "pointer"}} onClick={(e)=>{
                e.preventDefault()
                props.showSettingbarAction(false)
                handleLogout()
              }}>
                <span className="mb-2 d-block">로그아웃 하기</span>
                <img src={logOut} width={16} height={16} />
              </div>
              <hr className="mt-1" />
              
            </div>
          </div>
        </SimpleBar>
      </div>
      <Link
        style={{cursor: "auto"}}
        to="#"
        onClick={e => {
          e.preventDefault()
          props.showSettingbarAction(false)
        }}
        className="rightbar-overlay"
      /> */}
    </React.Fragment>
  )
}

export default RightSidebar
